var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowOneLinkManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#323232"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_2629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_2629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0029 42.6943C52.5398 42.8704 53.0333 43.0906 53.4824 43.3545C53.9314 43.6183 54.3363 43.8983 54.6973 44.1943L56.6699 43.3887L58.1973 45.8604L56.5029 47.25C56.614 47.7127 56.6699 48.2173 56.6699 48.7637C56.6699 49.31 56.614 49.8146 56.5029 50.2773L58.1973 51.667L56.6699 54.1104L54.6973 53.3057C54.3363 53.6202 53.9313 53.9091 53.4824 54.1729C53.0333 54.4367 52.5398 54.6569 52.0029 54.833L51.6699 57H48.8916L48.5859 54.833C48.0491 54.6569 47.5565 54.4367 47.1074 54.1729C46.6583 53.909 46.2527 53.6203 45.8916 53.3057L43.9199 54.1104L42.3916 51.667L44.0859 50.2773C43.9749 49.8146 43.9199 49.31 43.9199 48.7637C43.9199 48.2173 43.9748 47.7127 44.0859 47.25L42.3916 45.8604L43.9199 43.3887L45.8916 44.1943C46.2527 43.8982 46.6583 43.6184 47.1074 43.3545C47.5565 43.0907 48.0492 42.8704 48.5859 42.6943L48.8916 40.5H51.6699L52.0029 42.6943ZM50.2803 44.8057C49.1599 44.8058 48.2221 45.1829 47.4678 45.9375C46.7132 46.6919 46.3359 47.6296 46.3359 48.75C46.3359 49.8702 46.7132 50.8078 47.4678 51.5625C48.2221 52.3168 49.1599 52.6942 50.2803 52.6943C51.4004 52.6943 52.3381 52.3168 53.0928 51.5625C53.8472 50.8078 54.2246 49.8703 54.2246 48.75C54.2246 47.6294 53.8472 46.6919 53.0928 45.9375C52.3381 45.1829 51.4004 44.8057 50.2803 44.8057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6113 34.4443H31.667C30.1237 34.4443 28.8114 34.9837 27.7314 36.0625C26.6512 37.1413 26.1114 38.4519 26.1113 39.9932C26.1113 41.5346 26.6512 42.8473 27.7314 43.9307C28.8114 45.014 30.1237 45.5557 31.667 45.5557H38.6113V48.333H31.667C29.3614 48.333 27.3955 47.5205 25.7705 45.8955C24.1457 44.2706 23.333 42.3054 23.333 40C23.333 37.6946 24.1457 35.7294 25.7705 34.1045C27.3955 32.4795 29.3614 31.667 31.667 31.667H38.6113V34.4443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5283 41.3887H33.4717V38.6113H46.5283V41.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.333 31.667C50.6386 31.667 52.6045 32.4795 54.2295 34.1045C55.8543 35.7294 56.667 37.6946 56.667 40H53.8887C53.8887 38.4631 53.3488 37.1527 52.2686 36.0693C51.1886 34.986 49.8763 34.4443 48.333 34.4443H41.3887V31.667H48.333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowOneLinkManager);
export default __webpack_public_path__ + "static/media/icon-flow-one-link-manager.7b1907fb7015bde44265ad62bc2dc233.svg";
export { ForwardRef as ReactComponent };